import { Capacitor } from '@capacitor/core'

const PRODUCTION_API_URL = 'https://optioneer-production.up.railway.app'

function getLocalDevelopmentApiUrl() {
  return ['http://', 'localhost', ':8000'].join('')
}

function normalizeBaseUrl(value?: string | null) {
  return (value || '').trim().replace(/\/+$/, '')
}

function hostnameLooksLocal(hostname: string) {
  const normalized = hostname.toLowerCase()

  if (
    normalized === 'localhost' ||
    normalized === '0.0.0.0' ||
    normalized === '::1' ||
    normalized === '[::1]' ||
    normalized.startsWith('127.')
  ) {
    return true
  }

  const octets = normalized.split('.').map((part) => Number.parseInt(part, 10))
  if (octets.length !== 4 || octets.some((part) => Number.isNaN(part))) {
    return false
  }

  const [first, second] = octets
  return (
    first === 10 ||
    (first === 172 && second >= 16 && second <= 31) ||
    (first === 192 && second === 168)
  )
}

export function isLocalNetworkUrl(value?: string | null) {
  const normalized = normalizeBaseUrl(value)
  if (!normalized) return false

  try {
    return hostnameLooksLocal(new URL(normalized).hostname)
  } catch {
    return false
  }
}

export function resolveApiBaseUrl({
  configuredUrl,
  isNative,
  isProduction,
}: {
  configuredUrl?: string | null
  isNative: boolean
  isProduction: boolean
}) {
  const configured = normalizeBaseUrl(configuredUrl)

  if (configured && !(isNative && isProduction && isLocalNetworkUrl(configured))) {
    return configured
  }

  if (isNative || isProduction) {
    return PRODUCTION_API_URL
  }

  return getLocalDevelopmentApiUrl()
}

export const API_BASE_URL = resolveApiBaseUrl({
  configuredUrl: import.meta.env.VITE_API_URL,
  isNative: Capacitor.isNativePlatform(),
  isProduction: import.meta.env.PROD,
})
